/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum HousingIntakeScenarioStatus {
    OPEN = 'Open',
    CLOSED = 'Closed',
    ARCHIVED = 'Archived',
    DRAFT = 'Draft',
    MIGRATED = 'Migrated',
}
